import Modal from "@/components/Modal";
import SkeletonRow from "@/components/SkeletonRow";
import { BackgroundGradient } from "@/components/ui/background-gradient";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import useDataPendaftaran from "@/hooks/useDataPendaftaran";
import useSessionStorage from "@/hooks/useSessionStorage";
import { getListBerkasPenerimaan } from "@/services/getData";
import { DataBerkas, SysBerkas } from "@/types";
import { useState } from "react";
import { FaCheck } from "react-icons/fa6";
import { IoFolderOpen } from "react-icons/io5";
import { LuDownload, LuUpload } from "react-icons/lu";
import { useQuery } from "@tanstack/react-query";
import Form from "./Form";
import useTimePeriode from "@/hooks/useTimePeriode";
import PdfViewer from "@/components/PdfViewer";

export default function UnggahBerkas({
  idDataPendaftaran,
}: {
  idDataPendaftaran: string;
}) {
  // const [searchParams] = useSearchParams();
  // const sessionPeriode?.id_sys_periode = searchParams.get("periode");
  const [sessionPeriode] = useSessionStorage("sessionPeriode", {
    id_sys_periode: "",
  });
  const { isPendingPeriode, timePassedActive } = useTimePeriode();

  const { isValidPendaftaran } = useDataPendaftaran();

  const [showUpload, setShowUpload] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [selectedRow, setSelectedRow] = useState<SysBerkas | null>(null);
  const [selectedBerkas, setSelectedBerkas] = useState<DataBerkas | null>(null);

  const { data, isPending } = useQuery({
    queryKey: ["listDataBerkas", sessionPeriode?.id_sys_periode],
    queryFn: () =>
      getListBerkasPenerimaan(sessionPeriode?.id_sys_periode || ""),
  });

  return (
    <div>
      <div className="mb-5 flex flex-wrap justify-between">
        <h1 className="font-bold text-xl">Berkas</h1>
      </div>

      {isPending || isPendingPeriode ? (
        <div className="flex flex-col gap-y-3">
          {Array(5)
            .fill(null)
            .map((_, index) => {
              return <SkeletonRow key={index} />;
            })}
        </div>
      ) : (
        <section className="p-5 flex-1 overflow-auto rounded-xl border">
          <table className="table-auto w-full border-collapse border rounded-xl overflow-hidden">
            <thead>
              <tr>
                <th className="px-2 py-1 font-semibold border">No</th>
                <th className="px-2 py-1 font-semibold border">
                  Jenis Dokumen
                </th>
                <th className="px-2 py-1 font-semibold border">Keterangan</th>
                <th className="px-2 py-1 font-semibold border">Format</th>
                <th className="px-2 py-1 font-semibold border">Status</th>
                <th className="px-2 py-1 font-semibold border">Berkas</th>
                <th className="px-2 py-1 font-semibold border">
                  {!isValidPendaftaran ? "Aksi" : ""}{" "}
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.listSysBerkas &&
                data?.listSysBerkas?.length > 0 &&
                data.listSysBerkas?.map((row: SysBerkas, index: number) => {
                  const berkasSiswa = data?.listDataBerkasSiswa.find(
                    (berkas: DataBerkas) => {
                      return berkas?.id_sys_berkas == String(row.id_sys_berkas);
                    },
                  );

                  const isUploaded = data?.listDataBerkasSiswa
                    ? data?.listDataBerkasSiswa.find((berkas: DataBerkas) => {
                        return (
                          berkas?.id_sys_berkas == String(row.id_sys_berkas)
                        );
                      })
                    : false;

                  return (
                    <tr key={row.id_sys_berkas}>
                      <td className="px-2 py-1 border">
                        <div
                          className={`h-8 w-8 rounded-full flex justify-center items-center font-bold bg-primary text-white`}
                        >
                          {isUploaded ? <FaCheck /> : index + 1}
                        </div>
                      </td>
                      <td className="px-2 py-1 border">
                        {row.jenis_berkas?.nama_jenis_berkas}
                      </td>
                      <td className="px-2 py-1 border">
                        {row?.keterangan_berkas}{" "}
                        {row.is_wajib ? (
                          <span className="text-red-500">*(Wajib)</span>
                        ) : (
                          ""
                        )}
                      </td>

                      <td className="px-2 py-1 border">
                        {row.url_template_berkas ? (
                          <div className="w-fit mx-auto">
                            <BackgroundGradient
                              key={row.id_sys_berkas}
                              contentClassName="rounded-full"
                            >
                              <Button
                                variant={"secondary"}
                                className="flex gap-3 hover:bg-secondary/50"
                                onClick={() =>
                                  window.open(
                                    `${row.url_template_berkas}?id_sys_periode=${sessionPeriode?.id_sys_periode}`,
                                    "_blank",
                                  )
                                }
                              >
                                <LuDownload /> Unduh
                              </Button>
                            </BackgroundGradient>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                      <td className="px-2 py-1 border whitespace-nowrap text-center">
                        <Badge
                          variant={isUploaded ? "dark" : "secondary"}
                          className="whitespace-nowrap"
                        >
                          {isUploaded ? "Sudah" : "Belum"} Diupload
                        </Badge>
                      </td>
                      <td className="px-2 py-1 border">
                        {isUploaded && (
                          <Button
                            type="button"
                            variant={"ghost"}
                            onClick={() => {
                              setShowPdf(true);
                              setSelectedRow(row);
                              setSelectedBerkas(berkasSiswa);
                            }}
                            className="flex gap-3"
                          >
                            <IoFolderOpen /> Lihat
                          </Button>
                        )}
                      </td>

                      <td className="px-2 py-1 border">
                        {!isValidPendaftaran &&
                        !timePassedActive?.waktu_selesai_daftar_valid_selesai ? (
                          <div className="flex justify-center">
                            <Button
                              type="button"
                              variant={isUploaded ? "outline" : "secondary"}
                              className="flex gap-3 hover:bg-secondary/50"
                              onClick={() => {
                                setShowUpload(true);
                                setSelectedRow(row);
                              }}
                            >
                              <LuUpload />{" "}
                              {isUploaded ? "Upload Ulang" : "Upload"}
                            </Button>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </section>
      )}

      <Modal show={showUpload} onClose={() => setShowUpload(false)}>
        <Form
          method="POST"
          selectedRow={selectedRow}
          closeModal={() => setShowUpload(false)}
          idDataPendaftaran={idDataPendaftaran}
        />
      </Modal>

      <Modal
        show={showPdf}
        onClose={() => {
          setShowPdf(false);
          // Optional: clear selected setelah delay animasi
          setTimeout(() => setSelectedBerkas(null), 300);
        }}
        className="lg:w-[60vw] w-[95vw]"
      >
        <div className="flex flex-col gap-4 p-2">
          <div>
            <h1 className="font-bold text-lg text-slate-900 dark:text-white">
              {selectedBerkas?.sys_berkas?.jenis_berkas?.nama_jenis_berkas}
            </h1>
            {selectedBerkas?.nomor && (
              <Badge className="mt-2 bg-blue-100 text-blue-700 hover:bg-blue-100 dark:bg-blue-900/30 dark:text-blue-300">
                Nomor: {selectedBerkas?.nomor}
              </Badge>
            )}
          </div>

          {/* Panggil komponen PdfViewer */}
          {showPdf && selectedBerkas?.path_berkas && (
            <PdfViewer url={selectedBerkas.path_berkas} />
          )}
        </div>
      </Modal>
    </div>
  );
}
